import React from "react";
import { Button, Card, CardBody, Row, Col } from "reactstrap";
import { BsTrash, BsFillPencilFill } from "react-icons/bs";
import { USER_LEVEL } from "../../configs/constants"
import { getGridLineColor } from '../../helpers/utils'

const CardDevice = ({
  deviceId,
  organizationName,
  title,
  index,
  userLevel,
  onClick,
  onDelete,
  goAssign
}) => (
  <Card style={{ cursor: "pointer", marginBottom: "0px" }} className="card-chart">
    <CardBody style={{padding: "8px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
      <Row>      
        <Col xs={2} md={1} style={{display: "flex", alignItems: "center"}}>          
          {deviceId}
        </Col>
        <Col xs={4} md={3} style={{display: "flex", alignItems: "center"}}>
          {title}
        </Col>
        <Col xs={3} md={4} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {organizationName}
        </Col>
        <Col xs={6} md={4} style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <Button
              className="btn-fill btn-xs"
              style={{marginRight: "10px"}}
              color="primary"
              type="button"
              onClick={()=>goAssign(deviceId)}
          >
              Associar
          </Button>
          <BsTrash
            onClick={onDelete}
            className="icon-xs"
            title="Deletar"
            size= {20}
            color="#ec250d"
            visibility={userLevel !== USER_LEVEL.establishment ? "visible" : "hidden"}
          /> 
          <BsFillPencilFill              
              size= {20}
              className="icon-xs"
              style={{marginLeft: "5px", marginRight: "5px"}}
              title="Editar"
              onClick={onClick}
              color="#4cd678"
          />
        </Col>   
      </Row>
    </CardBody>
  </Card>
);

export default CardDevice;